<template>
<section>
  <section data-test="filter-organize-section">
    <div class="mt-2">
      <label class="from-label text-xxs text-gray-600" for="osm-select">หน่วยงาน</label>
      <v-select
        data-test="organize-select"
        id="organize-select"
        v-model="organizeComputed"
        :options="organizeOptions"
        :clearable="true"
        placeholder="กรุณาเลือกหน่วยงาน"
        :appendToBody="true"
        label="AGC_NAME"
        @update:modelValue="organizeSelected"
      >
        <template #no-options="">
          <p class="text-sm font-normal text-gray-500">
            ไม่พบข้อมูล
          </p>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
        </template>
      </v-select>
    </div>
  </section>
  <section data-test="filter-sub-organize-section">
    <div class="mt-2">
      <label class="from-label text-xxs text-gray-600" for="osm-select">หน่วยงานย่อย</label>
      <v-select
        data-test="sub-organize-select"
        id="sub-organize-select"
        v-model="subOrganizeComputed"
        :options="subOrganizeOptions"
        :clearable="true"
        placeholder="กรุณาเลือกหน่วยงานย่อย"
        :appendToBody="true"
        label="ORG_NAME"
      >
        <template #no-options="">
          <p class="text-sm font-normal text-gray-500">
            ไม่พบข้อมูล
          </p>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
        </template>
      </v-select>
    </div>
  </section>
  <section data-test="filter-province-section">
    <div class="mt-2">
      <label class="from-label text-xxs text-gray-600" for="osm-select">จังหวัด</label>
      <v-select
        data-test="province-select"
        id="province-select"
        v-model="provinceComputed"
        :options="provinceOptions"
        :clearable="true"
        placeholder="กรุณาเลือกจังหวัด"
        :appendToBody="true"
        label="province_name"
      >
        <template #no-options="">
          <p class="text-sm font-normal text-gray-500">
            ไม่พบข้อมูล
          </p>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
        </template>
      </v-select>
    </div>
  </section>
</section>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted, onUnmounted } from "vue";
import { getProvince, getOrganize, getSubOrganizeByOrganize} from "@/utils/get-option-data"

const props = defineProps({
  organize: Object,
  sub_organize: Object,
  province: Object,
});
const emits = defineEmits(["update:organize", "update:sub_organize", "update:province"]);

const organizeOptions = ref([])
const subOrganizeOptions = ref([])
const provinceOptions = ref([])

const organizeComputed = computed({
  get() {
    return props.organize;
  },
  set(evt) {
    emits("update:organize", evt);
  },
});
const subOrganizeComputed = computed({
  get() {
    return props.sub_organize;
  },
  set(evt) {
    emits("update:sub_organize", evt);
  },
});
const provinceComputed = computed({
  get() {
    return props.province;
  },
  set(evt) {
    emits("update:province", evt);
  },
});
const getSubOrganizeOptions = async (opt)=>{
  subOrganizeOptions.value = await getSubOrganizeByOrganize(opt)
}

watch(organizeComputed, (val) => {
  if (val) getSubOrganizeOptions(val)
  else subOrganizeOptions.value = [];
});
const organizeSelected = (val) =>{
  subOrganizeComputed.value = null
}
onMounted(async ()=>{
  provinceOptions.value = await getProvince()
  organizeOptions.value = await getOrganize()
})

</script>
